import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuoteRequestNoteModel } from '@app/quoting/models/quote-request-notes';
import { NoteShareType } from '@app/shared/enums/note-share-type';
import { QuoteRequestService } from '@app/shared/services/quote-request.service';
import { UtilityHubIdentity } from '@auth/models/utility-hub-identity';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { AppState } from '@app/state/app.state';
import { loggedInUtilityHubIdentitySelector } from '@app/state/app.selectors';

@Component({
  selector: 'app-quote-note-dialog',
  templateUrl: './quote-note-dialog.component.html',
  styleUrls: ['./quote-note-dialog.component.scss'],
})
export class QuoteNoteDialogComponent implements OnInit, OnDestroy {
  shareTypes: any[];
  public gridView: any;
  public frmQuoteNoteDialog: FormGroup;
  userIdentity: UtilityHubIdentity;
  selectLoggedInUtilityHubIdentity$: Subscription;
  quoteRequestId: any;
  dialog: any;
  dialogClosed$: any;
  selectQuote$: Subscription;
  quoteRequestNoteModels: QuoteRequestNoteModel[] = [];
  noteId: any;

  constructor(
    private formBuilder: FormBuilder,
    private store: Store<AppState>,
    private quoteRequestService: QuoteRequestService,
    @Inject(MAT_DIALOG_DATA) public data: { quoteRequestId: any }
  ) {
    this.quoteRequestId = data;
  }

  ngOnDestroy(): void {
    this.selectLoggedInUtilityHubIdentity$.unsubscribe();
  }

  ngOnInit(): void {
    this.selectLoggedInUtilityHubIdentity$ = this.store.select(loggedInUtilityHubIdentitySelector).subscribe((uhUser) => {
      this.userIdentity = uhUser;
    });

    this.initialForms();
    this.fillShareTypeByRoles();

    if (!isNaN(this.quoteRequestId)) {
      this.getQuoRequestNotes();
    }
  }

  initialForms() {
    this.frmQuoteNoteDialog = this.formBuilder.group({
      shareType: [NoteShareType.meOnly, Validators.compose([Validators.required])],
      text: ['', Validators.compose([Validators.required, Validators.maxLength(255)])],
    });
  }

  getQuoRequestNotes() {
    this.quoteRequestService.getQuoteRequestNotes(this.quoteRequestId).subscribe((resp) => {
      this.quoteRequestNoteModels = resp;
      this.gridView = resp;
    });
  }
  patchValuesToForm(quoteRequestNote: QuoteRequestNoteModel) {
    this.frmQuoteNoteDialog.patchValue({
      text: quoteRequestNote.text,
      shareType: quoteRequestNote.shareType,
    });
  }

  editNote(quoteRequestNote: QuoteRequestNoteModel) {
    this.noteId = quoteRequestNote.noteId;
    this.patchValuesToForm(quoteRequestNote);
  }
  cancel() {
    this.frmQuoteNoteDialog.reset();
    this.initialForms();
  }

  save() {
    if (!this.noteId) {
      let formValue = this.frmQuoteNoteDialog.value as QuoteRequestNoteModel;
      this.frmQuoteNoteDialog.markAllAsTouched();
      if (!this.frmQuoteNoteDialog.valid) return;
      formValue.ownerUserId = this.userIdentity.id;
      this.quoteRequestService.saveQuoteRequestNote(this.quoteRequestId, formValue).subscribe((resp) => {
        this.getQuoRequestNotes();
        this.cancel();
      });
    } else {
      let formValue = this.frmQuoteNoteDialog.value as QuoteRequestNoteModel;
      this.frmQuoteNoteDialog.markAllAsTouched();
      if (!this.frmQuoteNoteDialog.valid) return;
      formValue.ownerUserId = this.userIdentity.id;
      formValue.noteId = this.noteId;
      formValue.quoteRequestId = this.quoteRequestId;
      this.quoteRequestService.updateQuoteRequestNote(this.quoteRequestId, formValue).subscribe((resp) => {
        this.getQuoRequestNotes();
        this.cancel();
      });
    }
  }

  fillShareTypeByRoles() {
    let shareTypes = [
      {
        name: 'Visible to me Only',
        value: NoteShareType.meOnly,
      },
      {
        name: 'Visible to Other Supplier Managers and Sales Managers',
        value: NoteShareType.supplierManagerAndSalesManagerOnly,
      },
      {
        name: 'Visible to everyone',
        value: NoteShareType.everyOne,
      },
    ].filter((x) => (!this.userIdentity.isSupplierManagerOrSalesManager ? x.value != NoteShareType.supplierManagerAndSalesManagerOnly : x.value));
    this.shareTypes = shareTypes;
  }
}
